import Badge from '@yaak/components/src/Badge'
import { BadgeType } from '@yaak/components/src/Badge/Badge'
import React from 'react'
import classNames from 'classnames'
import style from '../pages/SimulatorRigsPage/style.less'

const HEALTH_STATUS_BADGE_TYPES: Record<string, string> = {
  OK: BadgeType.green,
  HEALTHY: BadgeType.green,
  PASS: BadgeType.green,
  PASSED: BadgeType.green,
  READY: BadgeType.green,
  WARN: BadgeType.yellow,
  WARNING: BadgeType.yellow,
  DEGRADED: BadgeType.yellow,
  ERROR: BadgeType.red,
  CRITICAL: BadgeType.red,
  FAIL: BadgeType.red,
  FAILED: BadgeType.red,
}

export const getHealthStatusBadgeType = (status: string): string => {
  return HEALTH_STATUS_BADGE_TYPES[status.toUpperCase()] ?? BadgeType.grey
}

export const getHealthStatusBadge = (
  status: string,
  options?: { large?: boolean }
) => (
  <div
    className={classNames(options?.large ? style.healthStatusLarge : undefined)}
  >
    <Badge type={getHealthStatusBadgeType(status)} label={status} withDot />
  </div>
)
